<template>
  <card class="mt-2">
    <form>
      <text-input required
        v-model="feature.title" 
        :error="errors.title" 
        error-class="has-text-danger">
      </text-input>
      <text-editor required
        source-sync
        v-model="feature.body" 
        :error="errors.body"
        :options="{
          toolbarFixed: false,
          source: true
        }">
      </text-editor>
      <submit-button
        v-bind="{ working }"
        @submit="saveFeature"
        class="is-success is-rounded">
        Save
      </submit-button>
    </form>
  </card>
</template>

<script>
import { mapState } from 'vuex'
import { save as saveFeature } from '@/api/feature'

export default {
  props: {
    rawFeature: Object
  },

  data: () => ({
    working: false,
    feature: {}
  }),

  created() {
    this.feature = this.rawFeature
  },

  methods: {
    saveFeature() {
      this.working = true
      saveFeature(this.feature, () => {
        this.$toast.success('Feature saved.')
        this.working = false
      }, () => {
        this.working = false
      })
    }
  }

}
</script>
